import { z } from 'zod'

export const alertRuleGroupSchema = z.object({
  id: z.string(),
  logicalOperator: z.string().nullable(),
  position: z.number().optional(),
})

export type TAlertRuleGroup = z.infer<typeof alertRuleGroupSchema>
